@if (showSuccess()) {
  <h4 class="mat-h4">{{ 'email_validation.label.success' | translate }}</h4>
  <p class="translation-text">{{ 'email_validation.text.success' | translate }}</p>
  <button color="primary" mat-flat-button routerLink="/" type="button">
    {{ 'email_validation.label.login' | translate }}
  </button>
}
@if (showResponseMessage()) {
  @if (response() && response().message) {
    <ebeihilfe-note [messageText]="response().message | translate" type="danger" />
  }
}

<form
  (submit)="submitValidationForm()"
  [attr.aria-label]="'a11y.form.validation' | translate"
  [formGroup]="validationForm"
  [hidden]="!showForm()"
  class="fill-remaining-space">
  <portal-username-input formControlName="personalNumber" />
  <portal-text-input
    [errors]="activationCodeErrors"
    autocomplete="off"
    formControlName="code"
    hint="info_text.input.activation_code"
    label="label.activation_code"
    placeholder="label.activation_code"
    type="text" />
  <portal-password-input
    [autocomplete]="passwordOptions.autocomplete"
    [createPasswordMode]="passwordOptions.createPasswordMode"
    [hint]="passwordOptions.hint"
    [id]="passwordOptions.id"
    [label]="passwordOptions.label"
    [placeholder]="passwordOptions.placeholder"
    formControlName="password" />
  <portal-password-input
    [autocomplete]="passwordRepeatOptions.autocomplete"
    [createPasswordMode]="passwordRepeatOptions.createPasswordMode"
    [errors]="passwordRepeatOptions.errors"
    [hint]="passwordRepeatOptions.hint"
    [id]="passwordRepeatOptions.id"
    [label]="passwordRepeatOptions.label"
    [placeholder]="passwordRepeatOptions.placeholder"
    formControlName="passwordRepeat" />
  <button [disabled]="validationForm.invalid" color="primary" mat-flat-button type="submit">
    {{ 'validation.label.button' | translate }}
  </button>
</form>
